/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TPrefetchFormDataModel,
  IPrefetchFormDataRequest,
  IMappers,
  IPrefetchFormDataResponse,
  IPrefetchFormDataResponseError,
  TPrefetchFormDataResponse,
} from './types';

const defaultConfig: TPrefetchFormDataModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'deal-rent-announcements',
  pathApi: '/v1/prefetch-form-data/',
  hostType: 'api',
} as TPrefetchFormDataModel;

function createPrefetchFormDataModel(parameters: IPrefetchFormDataRequest): TPrefetchFormDataModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPrefetchFormDataOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IPrefetchFormDataRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchPrefetchFormData<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IPrefetchFormDataOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TPrefetchFormDataResponse
> {
  const { response, statusCode } = await httpApi.fetch(createPrefetchFormDataModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPrefetchFormDataResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IPrefetchFormDataResponseError);
    }
  }

  return { response, statusCode } as TPrefetchFormDataResponse;
}

export { defaultConfig, createPrefetchFormDataModel, fetchPrefetchFormData };
